import React from 'react'
import { useFormContext, useFormState, useWatch } from 'react-hook-form'

const ActiveInputField = ({ field, control }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const error = errors[field.idFieldCanvas]
  const input_style = field.input_design ? { ...field.input_design } : {}
  const formContext = useFormContext()
  const register = formContext.register
  const inputProps = register(field.idFieldCanvas.toString(), {
    required: field.required,
    maxLength: field.has_max_length ? field.max_length : undefined,
  })

  let inputClass = ''

  if (isSubmitted) {
    inputClass = error ? 'input-error' : 'input-success'
  }

  const currentValue = useWatch({
    control,
    name: field.idFieldCanvas.toString(),
  })

  return (
    <>
      <input
        {...inputProps}
        defaultValue={field.VALUE__reponse ? field.VALUE__reponse : ''}
        type="text"
        className={inputClass}
        style={input_style || {}}
        placeholder={field.placeholder || ''}
        maxLength={field.has_max_length ? field.max_length : undefined}
      />
      {field.has_max_length && (
        <div
          style={{
            fontSize: '11px',
            color: input_style.color,
            marginTop: '10px',
            marginLeft: '5px',
          }}
        >
          {currentValue?.length || 0}/{field.max_length} caractères
        </div>
      )}
    </>
  )
}

const InactiveInputField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}
  const [value, setValue] = React.useState(field.VALUE__reponse || '')

  return (
    <>
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        type="text"
        style={input_style || {}}
        placeholder={field.placeholder || ''}
        maxLength={field.has_max_length ? field.max_length : undefined}
      />
      {field.has_max_length && (
        <div
          style={{
            fontSize: '11px',
            color: input_style.color,
            marginTop: '10px',
            marginLeft: '5px',
          }}
        >
          {value.length}/{field.max_length} caractères
        </div>
      )}
    </>
  )
}

const InputField = ({ field, control, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveInputField field={field} control={control} />
  ) : (
    <InactiveInputField field={field} />
  )
}

export default InputField
